import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import BoardListItem from '../components/BoardListItem/BoardListItem';

const makeMapStateToProps = () => {
  const selectBoardById = selectors.makeSelectBoardById();
  // const selectCurrentUserMembershipForBoard =
  // selectors.makeSelectCurrentUserMembershipForBoardById();
  // const selectOwnerCountForBoard = selectors.makeSelectOwnerCountForBoardById();
  const selectCurrentUserRoleAssignmentForBoard =
    selectors.makeSelectCurrentUserRoleAssignmentForBoardById();
  // console.log(
  //   'selectCurrentUserRoleAssignmentForBoard test',
  //   selectCurrentUserRoleAssignmentForBoard,
  // );

  return (state, { id }) => {
    const board = selectBoardById(state, id);
    // const currentUser = selectors.selectCurrentUserId(state);
    // const currentUserMembership = selectors.selectCurrentUserMembershipForBoard(state, id);
    // console.log('id test', id);
    const currentUserRoleAssignment = selectCurrentUserRoleAssignmentForBoard(state, id);
    // console.log('currentuserroleassignement test', currentUserRoleAssignment);
    const isCurrentUserOwner = selectors.selectIsOwnerBoard(state);
    const isCurrentUserEditor = selectors.selectCanEditBoard(state);
    // const ownerCount = selectOwnerCountForBoard(state, id);
    // const canLeave = !!currentUserMembership && (!isCurrentUserOwner || ownerCount > 1);
    const canLeave = !!currentUserRoleAssignment;
    // console.log('Valeur currentYUser Board');
    // console.log(currentUserRoleAssignment.userId);

    return {
      id,
      board,
      canEdit: isCurrentUserEditor,
      canDelete: isCurrentUserOwner,
      canLeave,
      // currentUser: currentUserRoleAssignment,
      currentUserRoleAssignmentId: currentUserRoleAssignment?.id ?? null, // currentUserMembership ? currentUserMembership.id : null,
    };
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onBoardUpdate: entryActions.updateBoard,
      onBoardDelete: entryActions.deleteBoard,
      onBoardLeave: entryActions.deleteUserRoleAssignment,
    },
    dispatch,
  );

export default connect(makeMapStateToProps, mapDispatchToProps)(BoardListItem);
